export default __webpack_public_path__ + "static/media/Unknown-0.92de73da.svg";